<template>
  <v-container fluid>
    <material-card
      icon="mdi-clipboard-text"
      inline
      title="Edit Student General Diary"
    >
      <v-card-actions>
        <router-link :to="{ name: 'viewStudentGeneralDiary' }">
          <v-btn
            v-if="$vuetify.breakpoint.smAndUp"
            elevation="1"
            absolute
            top
            right
          >
            <v-icon left>mdi-arrow-left</v-icon>back
          </v-btn>
          <v-btn
            v-else
            fixed
            right
            fab
            small
            color="grey lighten-2"
            elevation="1"
            class="mr-n2 mt-10"
            style="opacity: 0.6"
          >
            <v-icon>mdi-arrow-left</v-icon></v-btn
          >
        </router-link>
      </v-card-actions>
      <v-card flat class="px-2">
        <form @submit.prevent="save">
          <v-row>
            <v-col cols="12" md="4">
              <label class="body-2 font-weight-medium">
                Title <span class="error--text">*</span></label
              >
              <v-text-field
                class="my-0 py-1"
                v-model="title"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="8">
              <label class="body-2 font-weight-medium">
                General Remark <span class="error--text">*</span></label
              >
              <!-- <ckeditor required v-model="GeneralRemark" ref="ckeditorRef"></ckeditor> -->
              <!-- <textarea required clearable class="input" rows="3" v-model="GeneralRemark" ref="ckeditorRef"></textarea> -->
              <quill-editor
                v-model="GeneralRemark"
                theme="snow"
                ref="myQuillEditor"
              >
              </quill-editor>
            </v-col>
            <v-col cols="12">
              <label class="body-2 font-weight-medium"> Select file </label>
              <v-row no-gutters>
                <v-col cols="12" md="6" lg="4">
                  <b-field class="file is-primary">
                    <b-upload
                      @input="onFilechange()"
                      v-model="dropFile"
                      multiple
                      class="file-label"
                    >
                      <span class="file-cta">
                        <b-icon class="file-icon" icon="upload"></b-icon>
                        <span class="file-label">Click to upload</span>
                      </span>
                    </b-upload>
                  </b-field>

                  <span v-if="dropFile.length > 0">
                    <v-chip
                      v-for="(file, i) in dropFile"
                      :key="i"
                      color="primary"
                      label
                      outlined
                      class="mr-2 mt-2"
                      close
                      @click:close="deleteDropFile(i)"
                    >
                      {{ file.name }}
                    </v-chip>
                  </span>
                </v-col>
              </v-row>

              <div class="pink--text body-2">
                [ Allowed files: .gif, .png, .jpg, .jpeg, .xlsx, .xls, .csv,
                .doc, .pdf, .txt, .docx, .pptx, .pptm, .ppt, .xps, .potx,.potm,
                .pot, thmx, .ppsx, .pps, .ppam, .ppa, .mp3, .wma, .aac, .wav,
                .flac, .mp4, .avi, .m4p, .m4v, .wmv, .mov, .webm, .mpg, .mp2,
                .mpeg, .mpe, .mpv, .ogg, .flv, .mkv ]
              </div>
            </v-col>

            <v-col cols="12" md="12">
              <span v-if="dropFile1.length > 0">
                <label class="warning--text">Already Uploaded Documents</label>
                <div>
                  <v-chip
                    v-for="(file, i) in dropFile1"
                    :key="i"
                    color="primary"
                    label
                    outlined
                    class="mr-2 mt-2"
                    @click="download(file.urlPath)"
                    close
                    @click:close="deleteDropFile1(file.id)"
                  >
                    {{ file.name }}
                  </v-chip>
                </div>
              </span>
            </v-col>
            <v-col cols="12">
              <v-card-actions class="d-flex justify-end">
                <v-btn
                  :disabled="hasClicked"
                  bottom
                  right
                  elevation="1"
                  color="primary"
                  type="submit"
                >
                  <v-icon left> mdi-content-save </v-icon>
                  Save
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </form>
      </v-card>
    </material-card>
    <loading-icon :value="isLoading" />
  </v-container>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import Utils from '@/utils'
// import Vue from 'vue'
// import CKEditor from 'ckeditor4-vue'
// Vue.use(CKEditor)
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
export default {
  name: 'editStudentGeneralDiary',
  props: ['generalDiaryID'],
  components: { MaterialCard, quillEditor },
  data () {
    return {
      total: 0,
      dropFile: [],
      discription: '',
      type: '',
      title: '',
      typeData: [],
      GeneralRemark: '',
      generalDiary: [],
      documentData: [],
      hasClicked: false,
      isLoading: false,
      loader: true,
      sendData: {},
      selectedfranchiseeID: [],
      dropFile1: [],
      isWrite: false,
      deleteFileIdArr: [],
      loadingComponent: null,
      allowedFiles: [
        'gif',
        'png',
        'jpg',
        'jpeg',
        'xlsx',
        'xls',
        'csv',
        'doc',
        'pdf',
        'txt',
        'docx',
        'pptx',
        'pptm',
        'ppt',
        'xps',
        'potx',
        'potm',
        'pot',
        'thmx',
        'ppsx',
        'pps',
        'ppam',
        'ppa',
        'mp3',
        'wma',
        'aac',
        'wav',
        'flac',
        'mp4',
        'avi',
        'm4p',
        'm4v',
        'wmv',
        'mov',
        'webm',
        'mpg',
        'mp2',
        'mpeg',
        'mpe',
        'mpv',
        'ogg',
        'flv',
        'mkv'
      ]
    }
  },

  async created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.studentGeneralDiary()
    await this.studentGeneralDiaryDocuments()
  },
  beforeRouteLeave (to, from, next) {
    // Ckeditor maximize fix
    // const that = this.$refs.ckeditorRef
    // const maximizedState = that.instance.getCommand('maximize').state
    // if (maximizedState === 1) {
    //   that.instance.execCommand('maximize')
    // }
    // if (this.hasDataChanged() && !this.hasClicked) {
    //   return this.$dialog.warning({
    //     title: 'Leave Page',
    //     text: 'Do you really want to leave? you have unsaved changes!',
    //     actions: {
    //       false: 'No',
    //       true: {
    //         color: 'success',
    //         text: 'Yes',
    //         handle: () => {
    //           next()
    //         }
    //       }
    //     }
    //   })
    // } else
    next()
  },
  beforeMount () {
    window.addEventListener('beforeunload', this.preventNav)
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.preventNav)
  },
  methods: {
    preventNav (event) {
      if (!this.hasDataChanged()) return
      event.preventDefault()
      event.returnValue = ''
    },
    hasDataChanged () {
      const prevTitle = this.generalDiary.title
      const prevGeneralRemark = this.generalDiary.generalRemark
      // console.log(prevGeneralRemark)
      const boolAlert =
        this.GeneralRemark !== prevGeneralRemark ||
        this.dropFile.length > 0 ||
        this.title !== prevTitle
      return boolAlert
    },
    studentGeneralDiary: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(
          `${constants.API_URL}/api/communication/studentGeneralDairy/${this.generalDiaryID}`
        )
        this.generalDiary = data
        this.title = this.generalDiary.title
        this.GeneralRemark = this.generalDiary.generalRemark
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    studentGeneralDiaryDocuments: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(
          `${constants.API_URL}/api/communication/studentGeneralDairy/${this.generalDiaryID}`
        )
        this.documentData = data
        this.dropFile1 = this.documentData.studentGeneralDairyDocuments
        if (this.dropFile1) {
          this.dropFile1.forEach((docID) => {
            docID.name = docID.urlKey.substring(
              docID.urlKey.lastIndexOf('/') + 1
            )
          })
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    deleteDropFile (i) {
      this.dropFile.splice(i, 1)
    },
    deleteDropFile1 (docID) {
      this.$dialog.warning({
        title: 'Deleting File',
        text: '"Do you want to Delete this file"?',
        actions: {
          false: 'No',
          true: {
            color: 'success',
            text: 'Yes',
            handle: () => {
              this.dropFile1.forEach((element) => {
                if (docID === element.id) {
                  let index = this.dropFile1.indexOf(element)
                  if (index !== -1) {
                    this.dropFile1.splice(index, 1)
                  }
                  this.deleteFileIdArr.push(docID)
                }
              })
            }
          }
        }
      })
    },

    save: async function () {
      let GeneralRemarkTest = this.GeneralRemark
      GeneralRemarkTest = GeneralRemarkTest.replace(/(<([^>]+)>)/gi, '')
      GeneralRemarkTest = GeneralRemarkTest.replace(/&nbsp;/g, '')
      GeneralRemarkTest = GeneralRemarkTest.trim()
      if (
        GeneralRemarkTest === '' ||
        !GeneralRemarkTest ||
        GeneralRemarkTest === null
      ) {
        return this.$dialog.message.warning('Please fill General Remark', {
          position: 'Error',
          timeout: 4000
        })
      }
      if (this.deleteFileIdArr.length > 0) {
        this.deleteFileIdArr.forEach((docID) => {
          this.deleteDocument(docID)
        })
      }
      let formData = new FormData()
      formData.append('title', this.title)
      formData.append('generalRemark', this.GeneralRemark)
      for (let i = 0; i < this.dropFile.length; i++) {
        formData.append('file', this.dropFile[i])
      }
      this.hasClicked = true
      try {
        this.isLoading = true
        await http.put(
          `${constants.API_URL}/api/communication/studentGeneralDairy/${this.generalDiaryID}`,
          formData
        )
        this.loader = false
        this.$dialog.info({
          title: 'Success',
          text: 'Saved successfully'
        })
        this.$router.push({ name: 'viewStudentGeneralDiary' })
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While Details', errorMessage)
        this.lock = false
        this.hasClicked = false
        this.loader = false
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    download: async function (i) {
      try {
        let url = await http.get(
          `${constants.API_URL}/api/staff/downloadurl?s3urlKey=${i}`
        )
        window.open(url.data)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting file details, ${errorMessage}`)
      }
    },
    deleteDocument: async function (deldocID) {
      try {
        await http.get(
          `${constants.API_URL}/api/communication/studentGeneralDairy/status/${deldocID}`
        )
        // this.studentGeneralDiaryDocuments()
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    onFilechange () {
      let r = this.dropFile.some((a) => {
        return !this.allowedFiles.includes(a.name.split('.').pop())
      })
      if (r === true) {
        this.dropFile.pop()
        return this.$dialog.error({
          text: 'Kindly select allowed file formats only!',
          title: 'Error'
        })
      }
    }
  }
}
</script>
<style scoped>
textarea {
  background-color: #ffffff;
  border-color: #dbdbdb;
  border-radius: 4px;
  color: #363636;
  height: 9.5rem;
}
</style>
